export const educationData = [
    {
        id: 1,
        institution: 'Messiah University',
        course: 'B.S. Biology'
    },
    {
        id: 2,
        institution: 'PennWest California',
        course: 'B.S Athletic Training'
    },
    {
        id: 3,
        institution: 'Codecademy PRO',
        course: 'Front end engineering career path',
        startYear: '2021',
        endYear: '2022'
    },
]